import React from 'react'
import PropTypes from 'prop-types'
import { Transition, TransitionGroup } from 'react-transition-group'
import { gsap, ScrollSmoother, ScrollTrigger } from 'gsap-wrapper'
import ThemeProvider from 'styles/theme-provider'
import Footer from '../footer'
import Header from '../header'
import CookiesBanner from '../ui-elements/cookies-banner'
import 'styles/fonts.css'
import GlobalStyle from 'styles/global'
import { LayoutWrapper, PageWrapper, ContentWrapper } from './index.styled'

const LayoutContent = ({ children, location }) => {
  return (
    <TransitionGroup component={null}>
      <Transition key={location.pathname} timeout={{ enter: 1000, exit: 1000 }}>
        {(status) => (
          <div className={`page ${status}`}>
            <LayoutWrapper>{children}</LayoutWrapper>
          </div>
        )}
      </Transition>
    </TransitionGroup>
  )
}

const Layout = (props) => {
  const {
    children,
    location,
    pageContext: { layout },
  } = props
  const refWrapper = React.useRef(null)
  const scrollSmoother = React.useRef(null)
  //const [showSplash, setShowSplash] = React.useState(true)
  /*   React.useEffect(() => {
    if (showSplash && location.pathname !== '/') {
      setShowSplash(false)
    }
  }, [location, showSplash, setShowSplash]) */

  React.useLayoutEffect(() => {
    const gsapContext = gsap.context(() => {
      scrollSmoother.current = ScrollSmoother.create({
        content: '.home-content',
        wrapper: '.home-wrapper',
        smooth: 2,
        effects: true,
        normalizeScroll: { allowNestedScroll: true },
      })

      // fadeIn
      gsap.utils.toArray('.fadeIn').forEach(function (container) {
        ScrollTrigger.create({
          trigger: container,
          start: 'top 90%',
          end: '+=1000%',
          toggleClass: {
            targets: container,
            className: 'visible',
            toggle: 'add',
          },
          // once: true,
        })
      })
    }, [refWrapper])

    return () => gsapContext.revert()
  }, [children])

  // Scroll to anchor
  React.useEffect(() => {
    if (location.hash) {
      const timeout = setTimeout(() => {
        const hashWithoutHash = location.hash.substring(1)
        const targetElement = document.querySelector(
          `#${hashWithoutHash}-section`,
        )

        const height = document.querySelector('header').clientHeight

        if (targetElement) {
          gsap.to(scrollSmoother.current, {
            scrollTop: targetElement.offsetTop - height,
            duration: 0,
          })
        }
      }, 100)
      return () => clearTimeout(timeout)
    }
  }, [location.hash])

  return (
    <ThemeProvider location={location} scrollSmoother={scrollSmoother}>
      <div className="home-wrapper" ref={refWrapper}>
        <Header className={layout} />
        {/*  {showSplash && <Bird setShowSplash={setShowSplash} />} */}
        <div className="home-content">
          <PageWrapper>
            <GlobalStyle />
            <ContentWrapper>
              <LayoutContent location={location}>{children}</LayoutContent>
            </ContentWrapper>
            <Footer /* showSplash={showSplash} */ />
          </PageWrapper>
        </div>
      </div>
      <CookiesBanner />
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired,
}

export default Layout
